import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { CUSTOM_NAME_MAX_LENGTH } from "@syla/shared/types/requests/AddWalletRequest";
import React from "react";
import {
  FieldPath,
  FieldValues,
  get,
  RegisterOptions,
  UseFormReturn,
} from "react-hook-form";

type DataSourceNameFieldProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  registerOptions?: RegisterOptions<T, FieldPath<T>>;
  name: FieldPath<T>;
  isRequired?: boolean;
  isDisabled?: boolean;
} & Omit<
  InputProps,
  "name" | "value" | "defaultValue" | "onChange" | "onBlur" | "ref" | "form"
>;

/**
 * Data Source Name field for use in React Hook Form.
 */
export function DataSourceNameField<T extends FieldValues>({
  form,
  registerOptions,
  name,
  isRequired,
  isDisabled,
  ...props
}: DataSourceNameFieldProps<T>): React.ReactElement {
  const error = get(form.formState.errors, name);

  return (
    <FormControl
      isRequired={isRequired}
      isDisabled={isDisabled}
      isInvalid={!!error}
    >
      <FormLabel>Data source name</FormLabel>
      <Input
        placeholder="Enter data source name"
        maxLength={CUSTOM_NAME_MAX_LENGTH}
        {...props}
        {...form.register(name, registerOptions)}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
}
